export const getIcon = variant => {
  const icons = {
    default: 'fa-lightbulb',
    success: 'fa-check',
    info: 'fa-info-circle',
    warning: 'fa-exclamation-triangle',
    alert: 'fa-exclamation-triangle',
  };

  return icons[variant] || icons['default'];
};

export const getElementClass = variant => {
  return {
    'spw-message': true,
    [`spw-message--${variant}`]: true,
  };
};

export const shouldHideMessage = messageId => {
  return !!localStorage.getItem(`spw-message-${messageId}`);
};

export const dismissMessage = (messageId, hideCallback) => {
  localStorage.setItem(`spw-message-${messageId}`, 'true');
  hideCallback();
};
